import {BulkVosSettingsDto} from './bulkVosSettingsApi'

const DAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]

export function timeLabel(raw: string | undefined): string {
  if (!raw || !/^\d{1,2}:\d{2}(:\d{2})?$/.test(raw)) return raw || '10:30'
  const [h, m] = raw.split(':').map(Number)
  return new Date(2000, 0, 1, h, m || 0).toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  })
}

export function formatSummaryRaw(d: BulkVosSettingsDto): string {
  const unit = d.repeatUnit === 0 ? 'day' : d.repeatUnit === 2 ? 'month' : 'week'
  let dayLabel = 'Friday'
  for (let i = 0; i < 7; i++) {
    if (d.repeatDaysOfWeek & (1 << i)) {
      dayLabel = DAYS[i]
      break
    }
  }
  const dayPart =
    d.repeatUnit === 1
      ? ` on ${dayLabel}`
      : d.repeatUnit === 2
        ? ` on day ${clampMonthDay(d.repeatDayOfMonth)}`
        : ''
  let ends = 'ENDS NEVER'
  if (d.endsType === 1 && d.endsOnDate) {
    const datePart = d.endsOnDate.substring(0, 10)
    ends = `ENDS ON ${datePart}`
  }
  if (d.endsType === 2) ends = `ENDS AFTER ${d.endsAfterOccurrences ?? 0} OCCURRENCES`
  return `Time: ${timeLabel(d.scheduleTimeLocal)}. Repeat every ${d.repeatInterval} ${unit}${dayPart} ${ends}`
}

export function formatSummarySentence(d: BulkVosSettingsDto): string {
  const unit = d.repeatUnit === 0 ? 'day' : d.repeatUnit === 2 ? 'month' : 'week'
  const plural = d.repeatInterval === 1 ? unit : `${d.repeatInterval} ${unit}s`
  const every = d.repeatInterval === 1 ? `every ${unit}` : `every ${plural}`

  let days = ''
  if (d.repeatUnit === 1) {
    const picked = DAYS.filter((_, i) => d.repeatDaysOfWeek & (1 << i))
    days = picked.length ? ` on ${picked.join(', ')}` : ' — pick a day'
  } else if (d.repeatUnit === 2) {
    days = ` on the ${clampMonthDay(d.repeatDayOfMonth)}${ordinalSuffix(clampMonthDay(d.repeatDayOfMonth))}`
  }

  let ends = 'and never stops'
  if (d.endsType === 1) {
    ends = d.endsOnDate?.substring(0, 10)
      ? `until ${d.endsOnDate.substring(0, 10)}`
      : 'until a date you pick'
  }
  if (d.endsType === 2) ends = `for ${d.endsAfterOccurrences ?? 0} sends`

  return `Sends at ${timeLabel(d.scheduleTimeLocal)}, ${every}${days}, ${ends}.`
}

function clampMonthDay(value: number | undefined): number {
  if (value == null || Number.isNaN(value)) return 1
  return Math.min(31, Math.max(1, Math.trunc(value)))
}

function ordinalSuffix(day: number): string {
  if (day >= 11 && day <= 13) return 'th'
  const mod = day % 10
  if (mod === 1) return 'st'
  if (mod === 2) return 'nd'
  if (mod === 3) return 'rd'
  return 'th'
}

export function normalizeScheduleTime(value: string | undefined): string {
  if (!value) return '10:30'
  const match = value.match(/^(\d{1,2}):(\d{2})/)
  if (!match) return value
  return `${match[1].padStart(2, '0')}:${match[2]}`
}
